import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../redux/actions';
import * as pluginActions from '../../plugin/redux/actions';
import { EditorState } from 'draft-js';
import AgreementTemplateForm from './AgreementTemplateForm';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import ParentDocCard from '../../common/ParentDocCard';
import DocsLink from '../../../common/custom/DocsLink';
import { TemplateHeaderNav } from '../TemplateHeaderNav';
import { AGREEMENT_TEMPLATE } from 'drapcode-constant';
import * as commonActions from '../../common/redux/actions';


export class AgreementTemplate extends Component {
  static propTypes = {
    template: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  toggle = (activeTab) => {
    this.setState({ activeTab: activeTab });
  };
  static propTypes = {
    template: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    editorState: EditorState.createEmpty(),
    name: '',
    subject: '',
    collectionId: '',
    selectedCollectionFields: [],
  };

  componentDidMount = () => {
    const { match, actions, pluginActions } = this.props;
    const { projectId, version } = match.params;
    actions.loadProjectDetail({ projectId, version });
    actions.loadCollections({ projectId, version });
    pluginActions.loadAllInstalledPlugin({ projectId, version });
  };

  handleSubmit = (values) => {
    const { projectId, version } = this.props.match.params;
    values.projectId = projectId;
    let args = {
      projectId,
      version,
      values: values,
    };
    this.props.actions.createAgreementTemplate(args).then(() => {
      this.toggle(AGREEMENT_TEMPLATE);
    });
  };
  toggle = (activeTab) => {
    const { projectId, version } = this.props.match.params;
    this.props.history.push({
      pathname: `/template/${version}/v/${projectId}`,
      state: { activeTab: activeTab },
    });
  };

  render() {
    const { plugin, template ,projectDetail,match,actions} = this.props;
    const { editorState, name, collectionId, selectedCollectionFields, subject } = this.state;
    const { collections, createAgreementTemplatePending } = template;
    const { installedPlugins } = plugin;
    const {projectId ,version}=match.params
    return (
      <div className="main">
        <div className="section">
          <div className="container">
            <TemplateHeaderNav
              activeTab={AGREEMENT_TEMPLATE}
              title={'Agreement Templates'}
              toggle={this.toggle}
              installedPlugins={installedPlugins}
            />
            <div className="row mx-auto">
              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
                <div className="card">
                  <div
                    className="card-header card-header-icon"
                    data-background-color="drapcode-dark-blue"
                  >
                    <i className={`wb ${drapcodeIcon(AGREEMENT_TEMPLATE)}`}></i>
                  </div>
                  <div className="card-content">
                    <AgreementTemplateForm
                      handleSubmit={this.handleSubmit}
                      editorState={editorState}
                      name={name}
                      subject={subject}
                      collectionId={collectionId}
                      collections={collections}
                      selectedCollectionFields={selectedCollectionFields}
                      createAgreementTemplatePending={createAgreementTemplatePending}
                      projectDetail={projectDetail}
                      projectId={projectId}
                      version={version}
                      actions={actions}
                    />
                  </div>
                </div>
              </div>
              <ParentDocCard>
                <h5>
                  <b>Agreement Template</b>
                </h5>
                <p>
                  You can create custom Agreement Template and send them to different users. We have
                  created a step-by-step documentation that covers agreement template creation,
                  event configuration and execution.
                </p>
                <br />
                <DocsLink link="https://academy.drapcode.com/docs/app-event/event-dynamic-email-action/" />
              </ParentDocCard>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    template: state.template,
    plugin: state.plugin,
    projectDetail:state.common.projectDetail
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...commonActions }, dispatch),
    pluginActions: bindActionCreators({ ...pluginActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AgreementTemplate);
